import 'custombox/dist/custombox.min';
import 'custombox/dist/custombox.legacy.min';


// WEBPACK FOOTER //
// ./scripts/autoload/_custombox.js